import React from "react";
import { useTranslation } from "../../../context/Internationalization";
import ListTable from "../../../Components/Table/ListTable";
import ClubsTableRow from "./ClubsTableRow";

const schema = (t) => [
  {
    id: "logo",
    label: t("logo"),
    sortable: false,
    width: 72,
  },
  {
    id: "name",
    label: t("club_name"),
    sortable: false,
    minWidth: 200,
  },
  {
    id: "country",
    label: t("country"),
    sortable: false,
    minWidth: 140,
  },
  {
    id: "founded",
    label: t("founded"),
    sortable: false,
    minWidth: 120,
  },
  {
    id: "sport",
    label: t("sport"),
    sortable: false,
    minWidth: 140,
  },
  {
    id: "websiteUrl",
    label: t("website"),
    sortable: false,
    minWidth: 220,
  },
  {
    id: "isPremium",
    label: t("isPremium"),
    sortable: false,
    minWidth: 120,
  },
  {
    id: "actions",
    label: "",
    sortable: false,
    width: 64,
  },
];

const ClubsTable = ({ clubs = [], menuActions, lastElementRef, loading, emptyMessage }) => {
  const { t } = useTranslation();
  const rowElement = (club, index) => (
    <ClubsTableRow
      key={club._id}
      lastElementRef={lastElementRef}
      club={club}
      index={index}
      menuActions={menuActions}
    />
  );

  return (
    <ListTable
      rows={clubs}
      columns={schema(t)}
      rowElement={rowElement}
      tableAriaLabel={t("clubs_admin_panel")}
      minWidth={1120}
      loading={loading}
      emptyMessage={emptyMessage}
    />
  );
};

export default ClubsTable;
